import { Checkbox, ComboBox, IconButton, Label, Stack } from "@fluentui/react";
import * as React from "react";
import { IServiceSupplementaires } from "../../Models/IServiceSupplementaires";
import i18n from "../../Services/i18n";
import CustomStringServices from "../../Services/CustomStringServices/CustomStringServices";
import { ModalWithSimpleBanner } from "../ModalWithSimpleBanner";
import { NvxCustomBorderRadiusStack } from "../NvxCustomBorderRadiusStack";
import {
  IServicesSupplementaireProps,
  IServicesSupplementaireState,
} from "./ServicesSupplementaire.types";
 
export class ServicesSupplementaireComponent extends React.Component<
  IServicesSupplementaireProps,
  IServicesSupplementaireState
> {
  constructor(props: IServicesSupplementaireProps) {
    super(props);
    this.state = { showModal: false, showModalInfo: false, info: "" };
  }
 
  private _iconButtonStyles = {
    root: {
      color: this.props.theme.palette.neutralPrimary,
      marginLeft: "auto",
      marginTop: "4px",
      marginRight: "2px",
      width: "10px",
    },
    rootHovered: {
      color: this.props.theme.palette.neutralDark,
    },
  };
 
  private calculateAnimalMaximum(serviceCode: string): number {
    const nombrePetitAnimauxParGrosseCage = 1;

    if (serviceCode === "ANIMAL_S50") {
      const serviceInfo = this.props.informationservicesSupplementaires?.find(
        sinfo => sinfo.serviceCode === serviceCode
      );

      const animalP50Selected = this.props.serviceSupplementaires?.find(
        s => s.code === "ANIMAL_P50"
      );
      const quantiteP50 = animalP50Selected?.quantite || 0;
      return Math.max(0, (serviceInfo?.nombreDisponible || 0) - (quantiteP50 * nombrePetitAnimauxParGrosseCage));
    }
    
    if (serviceCode === "ANIMAL_P50") {
      const serviceInfo = this.props.informationservicesSupplementaires?.find(
        sinfo => sinfo.serviceCode === serviceCode
      );
      const animalS50Selected = this.props.serviceSupplementaires?.find(
        s => s.code === "ANIMAL_S50"
      );

      const serviceInfoS50 = this.props.informationservicesSupplementaires?.find(
        sinfo => sinfo.serviceCode === "ANIMAL_S50"
      );

      // Nombre de base S50 (sans conversion)
      const nombreBaseS50 = serviceInfoS50?.nombreMaximum || 0;
      
      // S50 excédentaires existants qui utilisent déjà des espaces P50
      let s50ExcedentairesExistants = 0;
      if(serviceInfoS50 && serviceInfoS50.nombreUtilise > nombreBaseS50) {
        s50ExcedentairesExistants = serviceInfoS50.nombreUtilise - nombreBaseS50;
      }
      
      // S50 sélectionnés par l'utilisateur
      const s50Selectionnes = animalS50Selected?.quantite || 0;
      
      // Total S50 qui ont besoin d'espace P50 (existants + nouveaux - espace de base disponible)
      const espacesS50Disponibles = Math.max(0, nombreBaseS50 - serviceInfoS50?.nombreUtilise || 0);
      const s50NecessitantP50 = Math.max(0, s50Selectionnes - espacesS50Disponibles);
      
      // Cages P50 supplémentaires nécessaires pour la sélection actuelle
      const cagesP50Supplementaires = Math.ceil(s50NecessitantP50 / nombrePetitAnimauxParGrosseCage);
      
      return Math.max(0, (serviceInfo?.nombreDisponible || 0) - cagesP50Supplementaires);
    }
 
    // Pour les autres services, retourner 0 (sera géré par la logique existante)
    return 0;
  }
 
  render(): JSX.Element {
 
    let colorServiceSupp = "red";
 
     if (this.props?.informationservicesSupplementaires?.every(service => service.estNombreValide)) {
      colorServiceSupp = "green";
    } else {
      colorServiceSupp = "red";
    }
 
    let afficherInfoServiceSupp = false;
 
    if (this.props.informationservicesSupplementaires !== undefined
    && this.props.informationservicesSupplementaires !== null
    && this.props.informationservicesSupplementaires.length > 0 ) {
      afficherInfoServiceSupp = true;
    }
 
    return (
      <Stack style={{ marginLeft: "10px" }}>
        {afficherInfoServiceSupp ? (
          <Stack style={{ marginTop: "15px" }}>
            <Label style={{ color: colorServiceSupp }}>
              {CustomStringServices.FormatServiceDisponibiliteMessage(
                this.props.informationservicesSupplementaires,
                i18n
              )}
            </Label>
          </Stack>) : ("")
        }
 
        <NvxCustomBorderRadiusStack
        {...this.props}
        title={i18n.t("SS:Title:ServeiceSupplementaire")}
        render={
          <Stack style={{ marginLeft: "25px", marginBottom: "20px" }}>
            {this.renderModal()}
            {this.props.passagerSelected
              ? this.props.serviceSupplementaires
                  ?.filter((s) => s.categorie === "PASSAGER")
                  .map((x) => {
                    return this.renderUnderComponent(x);
                  })
              : ""}
            {this.props.vehiculeSelected && this.props.passagerSelected
              ? this.props.serviceSupplementaires
                  ?.filter((s) => s.categorie === "VEHICULE")
                  .map((x) => {
                    return this.renderUnderComponent(x);
                  })
              : ""}
               {this.props.vehiculeSelected || this.props.passagerSelected
              ? this.props.serviceSupplementaires
                  ?.filter((s) => s.categorie === "PASSAGER_VEHICULE")
                  .map((x) => {
                    return this.renderUnderComponent(x);
                  })
              : ""}
          </Stack>
        }
      />
      </Stack>
    );
  }
 
  renderUnderComponent(x: IServiceSupplementaires) {
   
    let numberOptions = [];
    let maximum = 0;
   
    if(this.props.calculatorMode && x.nbMaximum)
    {
      maximum = x.nbMaximum;
    }
    else if (x.code === "ANIMAL_S50" || x.code === "ANIMAL_P50")
    {
      // Utiliser le calcul spécial pour les animaux
      maximum = this.calculateAnimalMaximum(x.code);
    }
    else
    {
      let serviceInfo = this.props.informationservicesSupplementaires
                                  ?.find(sinfo=> sinfo.serviceCode === x.code);
         maximum = serviceInfo?.nombreDisponible || 0;
    }
 
    // decider quoi afficher si pas d'espaces disponibles #30833
    for (let i = 0; i <= maximum; i++) {
        numberOptions.push({ key: i, text: i.toString() });
    }
 
    return (
      <Stack horizontal key={x.code} verticalAlign="center">
        <Label style={{ minWidth: "200px" }}>{x.libelle}</Label>
        { typeof x.nbMaximum === 'number' ?
          (
            <ComboBox placeholder=""
                        options={numberOptions}
                        selectedKey={x.quantite}
                        onChange={(event, option) => {
                            const selectedValue = Number(option?.key);
                            this.props.updateServiceSupplementaire(x, selectedValue > 0, selectedValue);
                          }}
                        styles={{ root: { minWidth: "70px", maxWidth: "70px" } }}/>
          )
        :
          (
            <Checkbox checked={x.isCheck}
                      onChange={(e, v) => {
                                this.props.updateServiceSupplementaire(x, v, v ? 1 : 0);
                              }}/>
          )
        }
        <IconButton
          style={{ marginLeft: "20px" }}
          iconProps={{ iconName: "FeedbackRequestSolid" }}
          styles={this._iconButtonStyles}
          onClick={() => {
            this.setState({ showModalInfo: true, info: x.bulleInformation });
          }}
        />
      </Stack>
    );
  }
  renderModal() {
    return (
      <Stack>
        <ModalWithSimpleBanner
          onClose={() => {
            this.setState({
              showModalInfo: false,
              info: "",
            });
          }}
          {...this.props}
          isOpen={this.state.showModalInfo}
          render={
            <Stack
              style={{
                marginLeft: "25px",
                marginRight: "25px",
                marginTop: "25px",
                minWidth: this.props.mobile ? "" : "500px",
                maxWidth: "700px",
              }}
            >
              {this.state.info}
            </Stack>
          }
        />
      </Stack>
    );
  }
}
 